export type XpressProfileMenuItem = {
  label: string
  // ชื่อไฟล์ไอคอนใน /images/profile/icon (ชุดเดียวกับเมนูฝั่ง ABC)
  icon: string
  iconSizeClass: string
  // ชื่อ route ใน router/xpress.ts
  to: string
}

export function useXpressProfileMenu() {
  const menuItems: XpressProfileMenuItem[] = [
    {
      label: 'บัตรกำนัล',
      icon: 'menu_2',
      iconSizeClass: 'tw-h-4',
      to: 'XpressProfileVoucher',
    },
    {
      label: 'คอร์สของฉัน',
      icon: 'menu_1',
      iconSizeClass: 'tw-h-8',
      to: 'XpressProfileCourse',
    },
  ]

  function getMenuItems() {
    return menuItems
  }

  return {
    getMenuItems,
  }
}
